/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { useUnstyled as d, classNames as i, uDropDownsBase as l } from "@progress/kendo-react-common";
import * as n from "react";
const g = (t) => {
  const {
    group: u,
    virtual: c,
    render: e,
    isMultiColumn: s = !1,
    id: m
  } = t, o = d(), r = o && o.uDropDownsBase, a = /* @__PURE__ */ n.createElement(
    "li",
    {
      id: m,
      role: "group",
      className: i(l.groupLi({ c: r, isMultiColumn: s })),
      style: s ? { boxSizing: "inherit" } : { position: c ? "relative" : "unset" }
    },
    /* @__PURE__ */ n.createElement("span", { className: e ? void 0 : i(l.groupItemText({ c: r, isMultiColumn: s })) }, u)
  );
  return e !== void 0 ? e.call(void 0, a, t) : a;
};
export {
  g as default
};
